/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Role} from './Role';

export interface DamCatalogPlain {
  id: number;
  header: string;
  icon?: string;
  syncUid?: string;
  htHead?: string;
  htDesc?: string;
  htKeywords?: string;
  channelIDs?: number[];
  termIDs?: number[];
  parentId?: number;
  iconId?: number;
  pictureId?: number;
  content?: string;
  enabled?: boolean;
  disabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  lft?: number;
  rgt?: number;
  level?: number;
  lastLevel?: boolean;
  productCount?: number;
  pos?: number;
  catalogTreeSynonym?: boolean;
  roles?: Role[];
}
